import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import s from './LoadingGeneration.module.css';
import sparkle from '../../../assets/img/Stars.svg';
import IconLogo from '../icons/IconLogo';

const loadingSteps = [
    'Analyzing your profile...',
    'Profile information retrieved...',
    'Scrapping past posts data...',
    'Selecting profile tone...',
    'Creating project...',
    'Post created! 100%...',
    'Scrapping past posts data...',
];

const LoadingGeneration: React.FC<{ isLogo?: boolean }> = ({ isLogo = true }) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentStepIndex((prevIndex) => {
                if (prevIndex < loadingSteps.length - 1) {
                    return prevIndex + 1;
                }
                return prevIndex;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return ReactDOM.createPortal(
        <div className={s.container}>
            {isLogo && (
                <div className={s.logo_container}>
                    <IconLogo />
                    <p>SimpleCreate</p>
                </div>
            )}

            <div className={s.center_content}>
                <img src={sparkle} className={s.sparkle} alt="logo" />
                <p className={s.text}>Generating</p>

                <div className={s.loading_bar_wrapper}>
                    <div className={s.loading_bar}></div>
                </div>

                <div className={s.loading_text}>
                    <p className={s.loading_text_item}>{loadingSteps[currentStepIndex]}</p>
                </div>
            </div>
        </div>,
        document.getElementById('modal-root') || document.body,
    );
};

export default LoadingGeneration;
